import { jsx as e, jsxs as r } from "react/jsx-runtime";

import { forwardRef as o, useLayoutEffect as t, useEffect as s, useImperativeHandle as a } from "react";

import n from "@ui-components-3/ui/lib/components/Drawer";

import { useCreateAvailability as i, CreateAvailabilityContext as l } from "../../hooks/useCreateAvailability.js";

import m from "@ui-components-3/ui/lib/utils/classNames";

import { useProviderSchedule as c } from "../../hooks/useProviderSchedule.js";

const d = o(((o, d) => {
    const {isDrawerOpened: p, toggleDrawer: u} = c();
    t((() => (document.body.style.overflow = p ? "hidden" : "unset", () => {
        document.body.style.overflow = "unset";
    })), [ p ]);
    const h = i(), {currentStep: y, currentTimezone: b, Content: f, resetFlow: w, showCreateError: v, drawerTitle: C} = h, {variantClassNames: N} = c();
    return s((() => {
        !p && y && w();
    }), [ y, p, w ]), a(d, (() => ({
        resetFlow: w,
        showCreateError: v
    })), [ w, v ]), e(l.Provider, {
        value: h,
        children: r(n, {
            opened: p,
            onClose: u(!1),
            onCustomClose: u(!1),
            className: "!z-[900]",
            children: [ e(n.Header, {
                className: "items-center border-b border-b-neutral-300 py-4",
                children: r("span", {
                    className: "flex items-center gap-3",
                    children: [ e("span", {
                        className: m("typography-body-xxl font-semibold", N.textMain),
                        children: C
                    }), !!b && r("span", {
                        className: "typography-body font-medium text-neutral-500",
                        children: [ "(", b, ")" ]
                    }) ]
                })
            }), e(f, {}) ]
        })
    });
}));

d.displayName = "AvailabilityDrawer";

export { d as default };
//# sourceMappingURL=index.js.map
